<template>
  <div class="badge">
    <div class="badge__color" :style="{ background: statusColor }"></div>
    {{ formatStatusText | capitalize }}
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: String,
      default: ""
    }
  },

  computed: {
    formatStatusText() {
      if (["not_submitted", "in_progress"].includes(this.status))
        return this.status.replace("_", " ");
      else return this.status;
    },
    statusColor() {
      switch (this.status) {
        case "approved":
          return "#2E48DA";
        case "rejected":
          return "#FF0000";
        case "processing":
          return "#FFA500";
        case "disbursed":
          return "#28A46E";
        case "repaid":
          return "#28A46E";
        case "overdue":
          return "#A020F0";
        case "not_submitted":
          return "#808080";
        case "cancelled":
          return "#FF0000";
        default:
          return "";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.badge {
  border-radius: 22px;
  border: 1px solid #b1b7d6;
  min-width: 120px;
  display: flex;
  align-items: center;
  width: fit-content;
  padding: 10px 24px;
  font-weight: 600;
  font-size: 12px;
  line-height: 23px;
  color: #0f0c3d;

  &__color {
    border-radius: 50%;
    width: 12px;
    height: 12px;
    margin-right: 7px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/general/statusBadge.vue